import { CommonModule } from '@angular/common';
import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenav, MatSidenavContainer, MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { IPaginationResult } from 'app/common/interfaces';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { FormatOtherDateHourPipe } from 'app/pipes/other-date.pipe';
import { getCode } from 'app/utils/method';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { debounceTime, distinctUntilChanged, Subject, Subscription, skip, take } from 'rxjs';
import { OpentItemsService } from '../reports/historic/open-item/open-items.service';
import AccountStatementsAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/account-statements/account-statements.entity';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import { BusinessPartnerService } from '../business-partners/business-partner/business-partner.service';
import { environment } from 'environments/environment.prod';
import { MatMenuModule } from '@angular/material/menu';
import SalesOfficeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity';
import { SalesOfficeService } from '../configuration/sales-office/sales-office.service';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { IFilters } from '../filters/interfaces/filterInterface';
import { PaymentConditionService } from '../master/payment-condition/payment-condition.service';
import PaymentConditionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/payment-condition/payment-condition.entity';
import { FilterSectionComponent } from 'app/common/components/filter-section/filter-section.component';
import { BusinessPartnersFiltersComponent } from '../filters/business-partners-filters/business-partners-filters.component';
import { ConfigurationFiltersComponent } from '../filters/configuration-filters/configuration-filters.component';
import { DatesFiltersComponent } from '../filters/dates-filters/dates-filters.component';
import { FinanceFiltersComponent } from '../filters/finance-filters/finance-filters.component';
import { RoutesFiltersComponent } from '../filters/routes-filters/routes-filters.component';
import { StatusFiltersComponent } from '../filters/status-filters/status-filters.component';
import { BankService } from '../payment-master/bank/bank.service';
import BankAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/payment-masters/bank/bank.entity';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { DateHelper } from 'app/utils/date.helper';
import { CompanyCurrencyPipe } from 'app/pipes/currency.pipe';


@Component({
  selector: 'app-open-p-item',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSidenavModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    FormatOtherDateHourPipe,
    MatSelectModule,
    NgxMatSelectSearchModule,
    MatMenuModule,
    FilterComponent,
    FilterSectionComponent,
    StatusFiltersComponent,
    DatesFiltersComponent,
    ConfigurationFiltersComponent,
    RoutesFiltersComponent,
    BusinessPartnersFiltersComponent,
    FinanceFiltersComponent,
    HoverMenuDirective,
    CompanyCurrencyPipe
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './open-p-item.component.html',
  styleUrl: './open-p-item.component.scss'
})
export class OpenPItemComponent implements OnInit, OnDestroy {
  getCode = getCode;
  private isInitialized = false;
  displayedColumns: string[] = [
    "businessPartner",
    "document",
    "codeReason",
    "creationDate",
    "expirationDate",
    "availableDays",
    "paymentConditionShort",
    "additionalOC",
    "totalAmount",
    "balance",
    "bank",
    "paymentCodeBank"
  ];

  dataSource = new MatTableDataSource<AccountStatementsAttributes>([]);

  totalItems: number = 0;
  searchControl = new FormControl('');
  search: string = '';
  pageSize: number = 50;
  pageIndex: number = 1;
  sortActive: keyof AccountStatementsAttributes = "creationDate";
  sortDirection: "ASC" | "DESC" = "DESC"

  filter = {
    dateini: null, //new Date(new Date().setDate(1)),
    salesOffice: null,
    businessPartners: null,
    type: null
  }

  businessPartnerList: BusinessPartnerAttributes[] = [];
  paymentConditionList: PaymentConditionAttributes[] = [];
  bankList: BankAttributes[]=[];
  searchBusiness = ''
  private searchSubjectBusiness = new Subject<string>();

  salesOfficeList: SalesOfficeAttributes[] = [];
  listFilterSalesOfficeList: SalesOfficeAttributes[] = [];
  searchOffice = ''

  fileToUpload: File;
  aux_file = false
  importType = null

  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup;

  loadConfigData = false;
  loadRoutesData = false;
  loadBusinessPartnersData = false;
  loadFinanceData = false;
  
  constructor(
    private opentItemsService: OpentItemsService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly businessPartnerService: BusinessPartnerService,
    private readonly searchService: SearchService,
    private readonly paymentService: PaymentConditionService,
    private readonly bankService: BankService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
  ) {
    this.form = this.fb.group({
      start: [],
      end: [],
      exp_start:[],
      exp_end: [],
      companyId: [],
      salesOfficeId: [],
      customerId:[],
      subRouteId: [],
      bankId: [],
      paymentConditionId: [],
    });
  }

  onConfigExpanded(): void {
    this.loadConfigData = true;
  }

  onRoutesExpanded(): void {
    this.loadRoutesData = true;
  }

  onBusinessPartnersExpanded(): void {
    this.loadBusinessPartnersData = true;
  }

  onFinanceExpanded(): void {
    if(!this.loadFinanceData){
      this.fetchAllPaymentCondition();
      this.fetchAllBank();
    }
    this.loadFinanceData = true;
  }

  ngOnInit(): void {
    this.onHandleSearch();
    this.onFilter();
    this.isInitialized = true;
  }

  ngAfterViewInit(): void {
    this.searchControl.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((filterValue: string) => {
        if (this.isInitialized) {
          this.pageIndex = 1;
          this.search = filterValue;
          this.onFilter();
        }
      });
  }

  onFilter() {
    this.getListReport()
  }

  onClearFilter() {
    this.filter = {
      dateini: null,
      salesOffice: null,
      businessPartners: null,
      type: null
    }

    this.onFilter()
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getListReport()
  }

  private fetchAllPaymentCondition(): void {
    this.paymentService.findToComboBox().subscribe({
      next: (res) => {
        this.paymentConditionList = res.data;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener condiciones de pagos.","Cerrar",{ duration: 5000});
      },
    });
  }

   private fetchAllBank(): void {
    this.bankService.findToComboBox().subscribe({
      next: (res) => {
        this.bankList = res.data;
        },
        error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener bancos.","Cerrar",{ duration: 5000});
      },
    });
  }


  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$
      .pipe(skip(1), debounceTime(300))
      .subscribe(term => {
        if (this.isInitialized) {
          this.applyFilter(term);
        }
      });
  }

  getListReport() {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }
    // let salesOffice = this.salesOfficeList.find(ele => ele._id == this.filter.salesOffice)

    let filter: IFilters = {
      startDate: DateHelper.getStartOfDay(this.form.get("start")?.value),
      endDate: DateHelper.getEndOfDay(this.form.get("end")?.value) ?? DateHelper.getEndOfDay(this.form.get("start")?.value) ?? null,
      expirationStartDate: DateHelper.getStartOfDay(this.form.get("exp_start")?.value) ?? null,
      expirationEndDate: DateHelper.getEndOfDay(this.form.get("exp_end")?.value) ?? DateHelper.getEndOfDay(this.form.get("exp_start")?.value) ?? null,
      companyId: this.form.get("companyId")?.value,
      salesOfficeId: this.form.get("salesOfficeId")?.value,
      customerId: this.form.get("customerId")?.value,
      subRouteId: this.form.get("subRouteId")?.value,//
      bankId: this.form.get("bankId")?.value,
      paymentConditionId: this.form.get("paymentConditionId")?.value,

    }

    this.opentItemsService.findAllWithCount(
      options,
      filter
      // this.filter.salesOffice ? (salesOffice ? salesOffice._id : null) : null,
      // this.filter.businessPartners ? [this.filter.businessPartners]: [], 
      // this.filter.dateini ? new Date(this.filter.dateini).toISOString() : null,
    ).subscribe({
      next: (res: IPaginationResult<AccountStatementsAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener información del reporte.", "Cerrar", { duration: 5000 });
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || 'ASC'
    this.getListReport()
  }

  changePage(e) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getListReport()
  }

  // Función para calcular los días vencidos
  getExpiredDays(expirationDate: Date): number {
    if (!expirationDate) {
      return 0;
    }

    const today = new Date();
    const expiration = new Date(expirationDate);

    today.setHours(0, 0, 0, 0);
    expiration.setHours(0, 0, 0, 0);

    if (isNaN(expiration.getTime())) {
      return 0; // Si la fecha es inválida, retorna 0 o el valor que consideres adecuado
    }

    const timeDifference = today.getTime() - expiration.getTime();
    const dayDifference = timeDifference / (1000 * 3600 * 24);
    return dayDifference > 0 ? Math.floor(dayDifference) : 0;
  }

  async handleFileInput(event) {
    this.aux_file = true
    this.fileToUpload = event.target.files[0];
    if (this.fileToUpload) {
      if (this.fileToUpload.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        this.snackBar.open("Ingrese solo de tipo .xlsx", "Cerrar", { duration: 3000 })
      }
    } else {
      this.aux_file = false
    }
  }

  setImportType(type: string) {
    this.importType = type;
  }

  onMessageConfirm() {
    if (this.fileToUpload) {

      let send = {
        file: this.fileToUpload
      }

      //formdata
      let formdata = new FormData()
      for (let key in send) {
        formdata.append(key, send[key])
      }

      if (this.importType == 'L') {
        this.opentItemsService.importFileBills(formdata).subscribe({
          next: (res: any) => {
            this.snackBar.open(res.message, "Cerrar", { duration: 3000 })
            this.aux_file = false
            this.importType = null
            this.getListReport()
          },
          error: (err) => {
            this.aux_file = false
            this.snackBar.open(err.error.message || 'Error al subir el registro', 'Cerrar', { duration: 3000 });
          },
        })
      } else if (this.importType == 'F') {
        this.opentItemsService.importFileNegotiable(formdata).subscribe({
          next: (res: any) => {
            this.snackBar.open(res.message, "Cerrar", { duration: 3000 })
            this.aux_file = false
            this.importType = null
            this.getListReport()
          },
          error: (err) => {
            this.aux_file = false
            this.snackBar.open(err.error.message || 'Error al subir el registro', 'Cerrar', { duration: 3000 });
          },
        })
      }
    }
  }

  //filter
  private getAllOfficeList(): void {
    this.salesOfficeService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
        this.listFilterSalesOfficeList = this.salesOfficeList.slice()
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener oficinas de venta.","Cerrar",{ duration: 5000});
      },
    });
  }

  changueOptionsOffice(event) {
    if (!this.salesOfficeList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterSalesOfficeList = this.salesOfficeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterSalesOfficeList = this.salesOfficeList.filter(item => item.externalKeys?.code.toLowerCase().indexOf(search) > -1 || item.name.toLowerCase().indexOf(search) > -1)
  }

  changeBusiness(event) {
    this.businessPartnerList = []
    this.getAllBusinessPartner(event)
  }

  private getAllBusinessPartner(salesOfficeId?): void {
    const materialOptions = {
      search: this.searchBusiness ? this.searchBusiness : null,
      currentPage: 1,
      limitPerPage: 50,
      sortActive: "name",
      //sortDirection: "ASC"
    };

    this.businessPartnerService.findAllWithCount(
      materialOptions,
        false,
      [],
      'both',
       null
    ).subscribe({
      next: (res: IPaginationResult<BusinessPartnerAttributes>) => {
        this.businessPartnerList = res?.data?.[0]?.data ?? [];
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al obtener socios de negocios.', 'Cerrar', { duration: 3000 });
      },
    })
  }

  changueOptionsBusiness(event) {
    this.searchSubjectBusiness.next(event)
  }

  private setupBusinessSearchControl(): void {
    this.searchSubjectBusiness
      .pipe(
        debounceTime(500),
        distinctUntilChanged()
      )
      .subscribe((searchTerm) => {
        if (searchTerm) {
          this.searchBusiness = searchTerm;
          this.getAllBusinessPartner();
        }
      });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
